module.exports = __webpack_public_path__ + "media/packs/images/flags/PF-e0d538a4c6ac9802473fa19009d04016.png";